import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../styles/Pages/ServiceDetailPage.css';
import { Spinner, SpinnerContainer } from '../styles/Spinner';
import ServicesData from '../data/Services/Services.json';
import Navigation from '../components/Navigation/Navigation';
import PhoneButton from '../components/PhoneButton';
import Footer from '../components/Footer';

const ServiceDetailPage = () => {
  const { id } = useParams();
  const [service, setService] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const selectedService = ServicesData.find(res => res.id.toString() === id);
    setService(selectedService);
  }, [id]);

  if (!service) return (
      <SpinnerContainer>
        <Spinner />
      </SpinnerContainer>
    ); 

  return (
    <div>
      <Navigation />
      <PhoneButton />
      <div className="service-detail">
        <div className="service-content-wrapper">
          <h2>{service.title}</h2>
          
          <div className="service-content">
            <p>{service.content}</p>
          </div>

          <div className="service-category">
            <span className="category-badge">{service.category}</span>
          </div>

          <div className="service-features">
            <h3>Key Features & Capabilities:</h3>
            <div className="features-grid">
              {service.keyFeatures.map((feature, index) => (
                <div key={index} className="feature-item">
                  <span className="feature-icon">✈️</span>
                  <span className="feature-text">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="service-benefits">
            <h3>Benefits & Advantages:</h3>
            <div className="benefits-grid">
              {service.benefits.map((benefit, index) => (
                <div key={index} className="benefit-item">
                  <span className="benefit-icon">🎯</span>
                  <span className="benefit-text">{benefit}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="more-details">
            <h3>Comprehensive Service Details:</h3>
            <p>{service.moreDetails}</p>
          </div>

          <div className="related-services">
            <h3>Related Travel Services:</h3>
            <ul>
              {service.related.map((relatedService, index) => (
                <li key={index}>{relatedService}</li>
              ))}
            </ul>
          </div>
          
          <button onClick={() => navigate(-1)} className="back-button">Go Back</button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ServiceDetailPage;
